module.exports = __webpack_public_path__ + "static/media/01-home.2b5e102a.png";